import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sijil_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getError = (e, fallback = "حدث خطأ، حاول مرة أخرى") => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
};

export default api;
